@for (section of sections; track $index) {
<div class="m-t-3">
    <p class="s1 fw-bold m-b-2">{{section.heading}}</p>
    <!-- attrs list -->
    <div [class.list-style-disc]="section.bulletPoints">
        @for (attribute of section.attributes; track $index) {
        @if (attribute) {
        @if (attribute.valuesLabels.length) {
        @if (attribute.mode === EMode.cms) {
        <!-- CMS content blocks -->
        @for (value of attribute.values; track $index) {
        <product-layout-details-general-item class="block"
                                             [variant]="[attribute.code, value].join('-')" />
        }
        } @else {
        <!-- static list -->
        <div class="flex flex-top">
            <!-- with optional title  -->
            @if (attribute.mode === EMode.attributeTitleValue) {
            <span class="p1">{{attribute.code | attributeLabel}}:&nbsp;</span>
            }
            <!-- value -->
            <div class="col-12 p1"
                 [innerHTML]="attribute.valuesLabels"></div>
        </div>
        }
        }
        }
        }
    </div>
</div>
}